<div
    [id]="id()"
    data-uitype="graph-container-time"
    class="w-full h-full relative bg-white"
>
    @if (!statusInfo().loaded) {
    <div
        class="absolute top-0 bottom-0 left-0 right-0 m-4 animate-pulse bg-dat-grey-100"
    ></div>
    }

    <div
        [class.opacity-0]="!statusInfo().loaded"
        [ngClass]="{
            'w-[calc(100%-100px)]': isHistorical(),
            'inline-block': isHistorical(),
            'w-full': !isHistorical()
        }"
        class="h-[380px] bg-white"
        data-uitype="graph"
        #graph
    ></div>
    <div
        [class.opacity-0]="!statusInfo().loaded"
        [class.hidden]="!isHistorical()"
        class="w-[80px] h-[380px] relative right-[10px] inline-block"
        data-uitype="graph-current"
        #currentGraph
    ></div>

    <!--#region Historical Legend -->
    @if(historicalLegend().length){
    <div
        [class.opacity-0]="!statusInfo().loaded"
        class="w-full flex items-center bg-white px-6 py-3 relative bottom-[6px]"
        data-uitype="graph-legend-historical"
    >
        @for (item of historicalLegend(); track item.id) {
        <div
            class="flex items-center"
            data-uitype="graph-legend-historical-node"
        >
            @if(item.toggle){
            <button
                (click)="toggleHistorical(item)"
                class="p-0 flex items-center justify-center ml-3"
            >
                <span
                    class="material-symbols-outlined iq-mat-icon-fill"
                    [class.iq-mat-icon-fill]="item.checked"
                    [class.text-dat-blue-500]="item.checked"
                >
                    {{ item.checked ? 'check_box' : 'check_box_outline_blank' }}
                </span>
            </button>
            } @if (item.iconType === 'circle') {
            <!-- div that is an empty circle with a colored border -->
            <div
                [style.borderColor]="item.color"
                class="mr-1 ml-2 w-2 h-2 border-solid border rounded-full"
            ></div>
            } @else {
            <div class="flex items-center ml-3" data-uitype="graph-legend-tick">
                <div [style.background]="item.color" class="w-3 h-3"></div>
                <div
                    [style.background]="item.color"
                    class="w-6 h-[2px] relative right-1/2"
                ></div>
            </div>
            }

            <div class="text-caption" data-uitype="graph-legend-title">
                {{ item.title }}
            </div>
        </div>
        }
    </div>
    }
    <!-- #endregion -->
    <!--#region Forecast Legend -->
    @if(forecastLegend().length){
    <div
        [class.opacity-0]="!statusInfo().loaded"
        class="w-full flex items-center bg-white px-6 py-3"
        data-uitype="graph-legend-historical"
    >
        @for (item of forecastLegend(); track item.id) {
        <div
            class="flex items-center"
            data-uitype="graph-legend-historical-node"
        >
            @if(item.toggle){
            <button
                (click)="toggleForecast(item)"
                class="p-0 flex items-center justify-center ml-3"
            >
                <span
                    class="material-symbols-outlined iq-mat-icon-fill"
                    [class.iq-mat-icon-fill]="item.checked"
                    [class.text-dat-blue-500]="item.checked"
                >
                    {{ item.checked ? 'check_box' : 'check_box_outline_blank' }}
                </span>
            </button>
            }
            <div class="flex items-center mx-3" data-uitype="graph-legend-tick">
                <div
                    [style.borderColor]="item.color"
                    class="w-4 h-2 mb-2 border-b-2 border-dashed"
                ></div>
            </div>
            <div class="text-caption" data-uitype="graph-legend-title">
                {{ item.title }}
            </div>
            @if(item?.tooltip?.length){
            <div class="ml-2 !text-caption text-dat-grey-900">
                <iq-tooltip-tooltip
                    [id]="id()"
                    [label]="tooltipIcon"
                    [tooltipBody]="item.tooltip"
                ></iq-tooltip-tooltip>
            </div>
            }
        </div>
        }
    </div>
    }
    <!-- #endregion -->
</div>
